import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards from "@/components/service/ServiceCards";
import ServiceQuoteSection from "@/components/service/ServiceQuoteSection";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import RoofCleaningQuoteForm from "./sections/RoofCleaningQuoteForm";
import { Waves, CloudRain, Zap, Shield, Trash2, Sparkles, Building2 } from "lucide-react";
const subServices = [{
  title: "Roof Tile Pressure Washing",
  description: "Carefully calibrated high-power cleaning for durable concrete and clay roof tiles, removing years of grime and stubborn organic matter.",
  icon: Waves
}, {
  title: "Roof Soft Washing",
  description: "A gentle, targeted treatment ideal for delicate roof tiles and slates, eliminating moss, lichen, and algae at the root without surface erosion.",
  icon: CloudRain
}, {
  title: "Low-Pressure Steam Wash",
  description: "Low-pressure, high-temperature steam cleaning that sanitises roof tile surfaces and lifts moss without the risk of tile abrasion.",
  icon: Zap
}, {
  title: "Moss & Algae Removal",
  description: "Specialised manual and mechanical removal of moss blankets to prevent water retention and structural tile damage.",
  icon: Shield
}, {
  title: "Gutter Cleaning",
  description: "Thorough debris removal and downpipe flushing to ensure your drainage system works perfectly alongside your clean roof.",
  icon: Trash2
}, {
  title: "Preventative Treatment",
  description: "Application of professional-grade biocide treatments to inhibit the return of moss and algae for years to come.",
  icon: Sparkles
}, {
  title: "Commercial Roof Cleaning",
  description: "Large-scale cleaning solutions for industrial units and commercial properties, maintaining professional standards and safety.",
  icon: Building2
}];
export default function RoofCleaningPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      <PageHero breadcrumbLabel="Roof Cleaning" breadcrumbParent={{
      label: "Services",
      to: "/ServicesHubPage"
    }} eyebrow="OUR SERVICES" title="Roof Cleaning in Southampton" intro="Professional roof cleaning, moss removal, and preventative treatments protecting properties across Southampton, Hampshire & surrounding areas." imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/roof_cleaning_precision.png" imageAlt="Professional roof cleaning and moss removal in Southampton by Firststop Roofing Ltd" actions />

      <ServiceIntro eyebrow="EXPERT OVERVIEW" heading="Professional Roof Cleaning & Moss Removal in Southampton" paragraphs={[<p key="p1">
            Looking for expert roof cleaning in Southampton? We deliver comprehensive roof care and moss removal for residential and commercial properties across Southampton, Hampshire &amp; surrounding areas. Our dedicated roofing specialists restore your roof tiles safely without compromising structural integrity.
          </p>, <p key="p2">
            Thick moss growth and damp organic matter can lift tiles and cause water ingress over harsh Hampshire winters. Our professional roofers in Southampton clear debris, treat spores at the root, and apply protective biocide treatments to keep your roof weather-tight and looking fresh for years to come.
          </p>]} benefits={["Moss & algae removal eliminating damaging organic growth across Southampton homes", "Full gutter clearing and downpipe inspection for optimal rainwater drainage", "Long-term biocide treatments protecting against the British coastal weather"]} imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/roof_after_1.png" imageAlt="Roof tiles restored and deep cleaned in Southampton by Firststop Roofing Ltd" cta />

      <ServiceCards eyebrow="OUR SERVICES" heading="Our Southampton Roof Cleaning Services" intro="Tailored roof cleaning and maintenance solutions designed to protect and enhance Southampton properties with proven roofing expertise." items={subServices} columns={3} />

      <ServiceQuoteSection id="get-a-free-quote" eyebrow="GET A FREE QUOTE" heading="Protect Your Southampton Property Today" intro="Request a fast, no-obligation quote from Matt for your roof cleaning or moss removal project in Southampton and surrounding areas." serviceName="Roof Cleaning">
        <RoofCleaningQuoteForm />
      </ServiceQuoteSection>

      <OtherServices currentKey="roof-cleaning" />

      <CtaBand />

      <Footer />
    </div>;
}